/**
 * @desc sku报价详情
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<defs.srm.SupplierQuotationResponseDto>;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
